import type { SVGProps } from 'react'
const SvgSyDoneRingRound = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={12} r={8} fillOpacity={0.24} />
		<path d="M19.076 5.576 11.5 13.15l-2.576-2.574-.848.848 2.893 2.894a.76.76 0 0 0 1.062 0l7.893-7.894z" />
		<path d="M10.764 4.096a8.003 8.003 0 0 0-5.27 12.56 8 8 0 0 0 14.354-6.207.5.5 0 0 0-.586-.392.5.5 0 0 0-.395.586A7 7 0 1 1 15.5 5.937a.5.5 0 0 0 .684-.183.5.5 0 0 0-.184-.682 8 8 0 0 0-5.236-.976" />
	</svg>
)
export default SvgSyDoneRingRound
